module.exports = __webpack_public_path__ + "files/95c3493e00dbdf606935105a8ace1ea1.png";